import React, { useState } from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    website: '',
    message: ''
  });

  const handleSubmit = () => {
    console.log('Form submitted:', formData);
    alert('Thank you for contacting us! We will respond shortly.');
    setFormData({ name: '', email: '', website: '', message: '' });
  };

  return (
    <div id="contact" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <p className="text-orange-500 font-semibold mb-2">Contact Support</p>
        <h2 className="text-4xl font-bold mb-8">Contact Us</h2>
        
        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <p className="text-gray-600 mb-8">
              We are committed to discussing the innovative IT solutions for your project 
              and talk about your project needs.
            </p>

            <div className="space-y-6">
              <div className="flex items-center gap-4">
                <div className="bg-orange-100 p-3 rounded-full">
                  <Mail className="text-orange-500" size={24} />
                </div>
                <span className="text-gray-700">example@example.com</span>
              </div>
              <div className="flex items-center gap-4">
                <div className="bg-orange-100 p-3 rounded-full">
                  <MapPin className="text-orange-500" size={24} />
                </div>
                <span className="text-gray-700">New York, Lahore, US</span>
              </div>
              <div className="flex items-center gap-4">
                <div className="bg-orange-100 p-3 rounded-full">
                  <Phone className="text-orange-500" size={24} />
                </div>
                <span className="text-gray-700">+123 234 7856</span>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <input
              type="text"
              placeholder="Name"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:border-orange-500"
            />
            <input
              type="email"
              placeholder="Email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:border-orange-500"
            />
            <input
              type="text"
              placeholder="Website"
              value={formData.website}
              onChange={(e) => setFormData({...formData, website: e.target.value})}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:border-orange-500"
            />
            <textarea
              placeholder="Message"
              rows="4"
              value={formData.message}
              onChange={(e) => setFormData({...formData, message: e.target.value})}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:border-orange-500"
            />
            <button 
              onClick={handleSubmit}
              className="w-full bg-orange-500 text-white px-8 py-3 rounded-lg hover:bg-orange-600 transition-colors"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;